module.exports = function(h) {
    if (this.opts.texts.title !== null) {
        let details = [];

        const tableName = this.$parent.tableName;
        const filters = this.$parent.filters;

        if (!_.isEmpty(tableName) && !_.isEmpty(filters)) {
            let grouped = _.groupBy(filters, 'filter_name');

            // workaround to support both filter_name and display_name attribute
            if (!_.isEmpty(grouped['undefined'])) {
                grouped = _.groupBy(filters, 'display_name');
            }

            _.forEach(grouped, (rows, filterName) => {
                let set = new Set();

                rows.forEach(row => {
                    if (!_.isEmpty(row.opl)) {
                        row.opl.map(o => {
                            set.add(o.display_name.trim());
                        });
                    } else if (row.opv) {
                        set.add(row.opv.display_name.trim());
                    }
                });

                let array = [...set];
                let spread = '';

                if (array.length > 5) {
                    array = array.slice(0, 5);
                    spread = '...';
                }

                let text =
                    array.length > 0 ? `: ${array.join(', ')} ${spread}` : '';

                details.push(
                    <small>
                        {filterName}
                        {text}
                    </small>,
                );
            });
        }

        return (
            <div class="pull-left VueTables__header-title">
                <h2>{this.opts.texts.title}</h2>
                <small>{this.opts.texts.description}</small>
                <small>{this.opts.texts.detail}</small>
                {!_.isEmpty(details) ? details : null}
            </div>
        );
    }

    return null;
};
